export const lotNumberConstants = {
  BASE_PATH: '/v1/building_profile/:sp_number/lot_numbers',
  GET_LOT_NUMBERS: 'GET_LOT_NUMBERS',
  SET_LOT_NUMBER_LOADING: 'SET_LOT_NUMBER_LOADING',
};
